import React from "react";
import { useEffect } from "react";
const Categories = () => {

useEffect(() => {
  window.scrollTo(0, 0);
}, []);



  useEffect(() => {

    const parallaxBox = document.getElementById("parallax");
    if (!parallaxBox) return;

    const layers = [];
    const speeds = [25, 20, 35, 30, 45, 30, 25, 40];

    for (let i = 2; i <= 9; i++) {
      const el = document.getElementById("l" + i);
      if (el) {
        layers.push({
          el,
          speed: speeds[i - 2]
        });
      }
    }

    const handleMove = (event) => {
      const rect = parallaxBox.getBoundingClientRect();

      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;

      const centerX = rect.width / 2;
      const centerY = rect.height / 2;

      layers.forEach(layer => {
        const moveX = (x - centerX) / layer.speed;
        const moveY = (y - centerY) / layer.speed;

        layer.el.style.transform = `translate(${moveX}px, ${moveY}px)`;
      });
    };

    parallaxBox.addEventListener("mousemove", handleMove);

    return () => {
      parallaxBox.removeEventListener("mousemove", handleMove);
    };

  }, []);

  return (
    <>
        <section className="hero-area bg-primary" id="parallax">
      <div className="container">
        <div className="row">
          <div className="col-lg-11 mx-auto">
            <h1 className="text-white font-tertiary">Categoryes</h1>
          </div>
        </div>
      </div>
      <div className="layer-bg w-100">
        <img className="img-fluid w-100" src="images/illustrations/leaf-bg.png" alt="bg-shape" />
      </div>
      <div className="layer" id="l2">
        <img src="/images/illustrations/dots-cyan.png" alt="bg-shape" />
      </div>
      <div className="layer" id="l3">
        <img src="/images/illustrations/leaf-orange.png" alt="bg-shape" />
      </div>
      <div className="layer" id="l4">
        <img src="/images/illustrations/dots-orange.png" alt="bg-shape" />
      </div>
      <div className="layer" id="l5">
        <img src="/images/illustrations/leaf-yellow.png" alt="bg-shape" />
      </div>
      <div className="layer" id="l6">
        <img src="/images/illustrations/leaf-cyan.png" alt="bg-shape" />
      </div>
      <div className="layer" id="l7">
        <img src="/images/illustrations/dots-group-orange.png" alt="bg-shape" />
      </div>
      <div className="layer" id="l8">
        <img src="/images/illustrations/leaf-pink-round.png" alt="bg-shape" />
      </div>
      <div className="layer" id="l9">
        <img src="/images/illustrations/leaf-cyan-2.png" alt="bg-shape" />
      </div>
      <ul className="list-unstyled ml-5 mt-3 position-relative zindex-1">
        <li className="mb-3"><a className="text-white" href="https://themefisher.com/"><i className="ti-facebook"></i></a></li>
        <li className="mb-3"><a className="text-white" href="https://themefisher.com/"><i className="ti-instagram"></i></a></li>
        <li className="mb-3"><a className="text-white" href="https://themefisher.com/"><i className="ti-dribbble"></i></a></li>
        <li className="mb-3"><a className="text-white" href="https://themefisher.com/"><i className="ti-twitter"></i></a></li>
      </ul>
    </section>
<section style={{ marginTop: "10%"}} className="section">

<div className="container">

    <div className="row">

        {/* ================= الأكثر مشاهدة ================= */}
        <div className="col-md-4 text-center">
        <h2 style={{color:'black'}} className="section-title mb-4">الأكثر مشاهدة</h2>

        {[
        {title:"Avatar",img:"https://image.tmdb.org/t/p/w500/jRXYjXNq0Cs2TcJjLkki24MLp7u.jpg"},
        {title:"Inception",img:"https://image.tmdb.org/t/p/w500/9gk7adHYeDvHkCSEqAvQNLV5Uge.jpg"},
        {title:"The Dark Knight",img:"https://image.tmdb.org/t/p/w500/qJ2tW6WMUDux911r6m7haRef0WH.jpg"},
        {title:"Interstellar",img:"https://image.tmdb.org/t/p/w500/rAiYTfKGqDCRIIqo664sY9XZIvQ.jpg"},
        {title:"Avengers Endgame",img:"https://image.tmdb.org/t/p/w500/or06FN3Dka5tukK1e9sl16pB3iy.jpg"},
        {title:"Titanic",img:"https://image.tmdb.org/t/p/w500/9xjZS2rlVxm8SFx8kPC3aIGCOYQ.jpg"},
        {title:"Joker",img:"https://image.tmdb.org/t/p/w500/udDclJoHjfjb8Ekgsd4FDteOkCU.jpg"},
        {title:"Gladiator",img:"https://image.tmdb.org/t/p/w500/ty8TGRuvJLPUmAR1H1nRIsgwvim.jpg"},
        {title:"Matrix",img:"https://image.tmdb.org/t/p/w500/aOIuZAjPaRIE6CMzbazvcHuHXDc.jpg"},
        {title:"MOONLIGHT",img:"https://posterhouse.org/wp-content/uploads/2021/05/moonlight_0.jpg"}
        ].map((film,index)=>(
        <div key={index} className="card shadow mb-4 p-2">
        <div className="card-body">
        <img style={{width:"100%",height:"400px",objectFit:"cover"}} src={film.img} alt={film.title}/>
        <h4 className="mt-3">{film.title}</h4>
        </div>
        </div>
        ))}

        </div>


        {/* ================= الأكثر مفضلة ================= */}
        <div className="col-md-4 text-center">
        <h2 style={{color:'black'}} className="section-title mb-4">الأكثر مفضلة</h2>
        {[
        {title:"Spider Man No Way Home",img:"https://image.tmdb.org/t/p/w500/1g0dhYtq4irTY1GPXvft6k4YLjm.jpg"},
        {title:"Doctor Strange",img:"https://image.tmdb.org/t/p/w500/uGBVj3bEbCoZbDjjl9wTxcygko1.jpg"},
        {title:"Black Panther",img:"https://image.tmdb.org/t/p/w500/uxzzxijgPIY7slzFvMotPv8wjKA.jpg"},
        {title:"Iron Man",img:"https://image.tmdb.org/t/p/w500/78lPtwv72eTNqFW9COBYI0dWDJa.jpg"},
        {title:"Thor Ragnarok",img:"https://image.tmdb.org/t/p/w500/rzRwTcFvttcN1ZpX2xv4j3tSdJu.jpg"},
        {title:"Deadpool",img:"https://image.tmdb.org/t/p/w500/3E53WEZJqP6aM84D8CckXx4pIHw.jpg"},
        {title:"Logan",img:"https://image.tmdb.org/t/p/w500/fnbjcRDYn6YviCcePDnGdyAkYsB.jpg"},
        {title:"Batman Begins",img:"https://image.tmdb.org/t/p/w500/4MpN4kIEqUjW8OPtOQJXlTdHiJV.jpg"},
        {title:"Shutter Island",img:"https://image.tmdb.org/t/p/w500/kve20tXwUZpu4GUX8l6X7Z4jmL6.jpg"},
        {title:"Fight Club",img:"https://image.tmdb.org/t/p/w500/bptfVGEQuv6vDTIMVCHjJ9Dz8PX.jpg"}
        ].map((film,index)=>(
        <div key={index} className="card shadow mb-4 p-2">
        <div className="card-body">
        <img style={{width:"100%",height:"400px",objectFit:"cover"}} src={film.img} alt={film.title}/>
        <h4 className="mt-3">{film.title}</h4>
        </div>
        </div>

        ))}

        </div>


        {/* ================= الأكثر شراء ================= */}
        <div className="col-md-4 text-center">
        <h2 style={{color:'black'}} className="section-title mb-4">الأكثر شراء</h2>
        {[
        {title:"Fast X",img:"https://image.tmdb.org/t/p/w500/fiVW06jE7z9YnO4trhaMEdclSiC.jpg"},
        {title:"JOKER",img:"https://creativereview.imgix.net/uploads/2019/12/joker_full.jpg?auto=compress,format&crop=faces,entropy,edges&fit=crop&q=60&w=1012&h=1500"},
        {title:"JUMANJI",img:"https://m.media-amazon.com/images/I/61KPF16khwS._AC_UF894,1000_QL80_.jpg"},
        {title:"Mission Impossible",img:"https://image.tmdb.org/t/p/w500/NNxYkU70HPurnNCSiCjYAmacwm.jpg"},
        {title:"Mad Max Fury Road",img:"https://image.tmdb.org/t/p/w500/hA2ple9q4qnwxp3hKVNhroipsir.jpg"},
        {title:"Top Gun Maverick",img:"https://image.tmdb.org/t/p/w500/62HCnUTziyWcpDaBO2i1DX17ljH.jpg"},
        {title:"The Batman",img:"https://image.tmdb.org/t/p/w500/74xTEgt7R36Fpooo50r9T25onhq.jpg"},
        {title:"Aquaman",img:"https://image.tmdb.org/t/p/w500/5Kg76ldv7VxeX9YlcQXiowHgdX6.jpg"},
        {title:"Wonder Woman",img:"https://image.tmdb.org/t/p/w500/v4ncgZjG2Zu8ZW5al1vIZTsSjqX.jpg"},
        {title:"Captain Marvel",img:"https://image.tmdb.org/t/p/w500/AtsgWhDnHTq68L0lLsUrCnM7TjG.jpg"}
        ].map((film,index)=>(
        <div key={index} className="card shadow mb-4 p-2">
        <div className="card-body">
        <img style={{width:"100%",height:"400px",objectFit:"cover"}} src={film.img} alt={film.title}/>
        <h4 className="mt-3">{film.title}</h4>
        </div>
        </div>
        ))}

        </div>

        </div>
      </div>
    </section>
    </>
  );
};

export default Categories;